import axios from 'axios';

export const cancelToken = axios.CancelToken;
